export const getFileExtension = (name: string): string | undefined => {
  const lastDot = name.lastIndexOf(".");
  if (lastDot <= 0 || lastDot === name.length - 1) {
    return undefined;
  }

  return name.slice(lastDot + 1).toLowerCase();
};
